import { Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PortCallModel } from '../../../../shared/models/port-call.model';
import { ArrayUtility } from '@solcre-org/core';
import { VoyageSummaryModel } from '../../../../shared/models/voyage-summary.model';

@Component({
  selector: 'app-voyage-portcall-nav',
  imports: [TranslateModule],
  templateUrl: './voyage-portcall-nav.html',
})
export class VoyagePortcallNav {
  //Inputs and outputs
  activeVoyage = input<VoyageSummaryModel | null>(null);
  activePortCall = input<PortCallModel | null>(null);
  changePortcallAsActive = output<PortCallModel>();

  //Models
  firstPortCall = computed(() => {
    return this.activeVoyage()?.portCalls[0];
  });
  lastPortCall = computed(() => {
    const portCallLengths: number = this.activeVoyage()?.portCalls.length ?? 0;
    return this.activeVoyage()?.portCalls[portCallLengths - 1];
  });

  //Events
  onChangePortCallAsActive(porCall: PortCallModel): void {
    this.changePortcallAsActive.emit(porCall);
  }

  onChangePortCallSelected(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const portCallId: number = +select.value;

    ArrayUtility.find(
      this.activeVoyage()?.portCalls ?? [],
      portCallId,
      (portCall: PortCallModel) => {
        this.onChangePortCallAsActive(portCall);
      }
    );
  }

  onPreviousPortCall(): void {
    //Find the previous port call
    //If there is no previous port call, do nothing
    ArrayUtility.each(
      this.activeVoyage()?.portCalls,
      (portCall: PortCallModel, index: number) => {
        const previousPortCall = this.activeVoyage()?.portCalls[index - 1];
        if (
          portCall.id === this.activePortCall()?.id &&
          previousPortCall !== undefined
        ) {
          this.onChangePortCallAsActive(previousPortCall);
        }
      }
    );
  }

  onNextPortCall(): void {
    //Find the next port call
    //If there is no next port call, do nothing
    ArrayUtility.each(
      this.activeVoyage()?.portCalls,
      (portCall: PortCallModel, index: number) => {
        const previousPortCall = this.activeVoyage()?.portCalls[index + 1];
        if (
          portCall.id === this.activePortCall()?.id &&
          previousPortCall !== undefined
        ) {
          this.onChangePortCallAsActive(previousPortCall);
        }
      }
    );
  }
}
